import type { ApiClient, ApiDataResponse } from '@commander/api-client';

export const createIntegrationsService = (apiClient: ApiClient) => ({
  async connectTwentyCRM(params: {
    companyId: string;
    apiKey: string;
    crmUrl: string;
  }): Promise<any> {
    const { companyId, apiKey, crmUrl } = params;
    const response = await apiClient.post<ApiDataResponse<any>>(
      `/company/${companyId}/twenty_crm_instance`,
      {
        api_key: apiKey,
        crm_instance_url: crmUrl,
      }
    );
    return response;
  },
});
